import { defineMessage } from '../../../../services/localization';

export const messages = {
    fullscreen: defineMessage('full_screen'),
    sideBySide: defineMessage('sidebyside'),
};
